export default __webpack_public_path__ + "static/media/register-background.b4063ab4.png";